module.exports = __webpack_public_path__ + "img/9788949120867.eaaeb239.jpg";